import React, { useState } from "react";
import "../../css_files/Quotation/QuotationCard.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import getCookie from "../../api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import axiosInstance from "../../api";

function QuotationCard({
  quotation,
  setQuotationId,
  setTicketId,
  setEnquiryId,
  setrefresh,
  refresh,
  deletePermission,
  updatePermission,
}) {
  const nav = useNavigate();
  const [deleteLoader, setDeleteLoader] = useState(false);
  return (
    <aside className="quotation-card">
      <p>
        <strong>Series Id: </strong>
        {quotation.seriesId}
      </p>
      <p>
        <strong>Linked to Ticket Id: </strong>
        {quotation.ticketId}
      </p>
      <p>
        <strong>Linked to Enquiry Id: </strong>
        {quotation.ticket?.enquirySeriesId}
      </p>
      <p>
        <strong>Company/Organization Name: </strong>
        {quotation.customer.orgName}
      </p>
      <div>
        <p>
          <strong>Sub Total: </strong>
          {quotation.symbol} {quotation.subTotal}
        </p>
        <p>
          <strong>Final Total: </strong>
          {quotation.symbol} {quotation.finalTotal}
        </p>
        <p>
          <strong>GST Amount: </strong>
          {quotation.symbol} {quotation.gstAmount}
        </p>
        <p>
          <strong>GST Percentage: </strong>
          {quotation.gstPercentage}%
        </p>
        <p>
          <strong>Discount Amount: </strong>
          {quotation.symbol} {quotation.discountValue}
        </p>
        <p>
          <strong>Discount: </strong>
          {quotation.discountPercentage}%
        </p>
        <p>
          <strong>Enquiry Type: </strong>
          {quotation.enquiryType}
        </p>
        <p>
          <strong>Grand Total: </strong>
          {quotation.symbol} {quotation.grandTotal}
        </p>
      </div>
      <blockquote>
        <i
          className="fa-solid fa-eye"
          onClick={() => {
            axiosInstance
              .get(
                `${
                  process.env.REACT_APP_API_URL
                }/api/v1/Ticket/${encodeURIComponent(quotation.ticketId)}`
              )
              .then((res) => {
                setEnquiryId(res.data.enquirySeriesId);
                setTicketId(quotation.ticketId);
                setQuotationId(quotation.seriesId);
                nav("/dashboard/checkin/steps/step3");
              })
              .catch(console.log);
            nav("/dashboard/checkin/steps/step3");
          }}
        ></i>
        <i
          className="fa-solid fa-pen-to-square"
          onClick={() =>
            nav(`/dashboard/quotations/edit/${quotation.seriesId}`)
          }
          style={{
            pointerEvents: updatePermission() && "none",
            color: updatePermission() && "gray",
          }}
        ></i>
        {deleteLoader ? (
          <i class="fa-solid fa-hurricane fa-spin" title="Please Wait..."></i>
        ) : (
          <i
            className="fa-solid fa-trash"
            onClick={() => {
              Swal.fire({
                icon: "error",
                showCancelButton: true,
                title: "Are you sure?",
              }).then((result) => {
                if (result.isConfirmed) {
                  setDeleteLoader(true);
                  axiosInstance
                    .put(`${process.env.REACT_APP_API_URL}/api/v1/Quotation`, {
                      SeriesId: quotation.seriesId,
                      isDeleted: true,
                    })
                    .then((res) => {
                      toast.success("Record Deleted Successfully", {
                        position: "bottom-center",
                        theme: "dark",
                      });
                      setrefresh(!refresh);
                    })
                    .catch(console.log)
                    .finally(() => {
                      setDeleteLoader(false);
                    });
                }
              });
            }}
            style={{
              pointerEvents: deletePermission() && "none",
              color: deletePermission() && "gray",
            }}
          ></i>
        )}
      </blockquote>
    </aside>
  );
}

export default QuotationCard;
